import { Suspense } from 'react';
import { Provider } from 'react-redux';
import App from './components/App';
import store from 'store/store';
import './theme/index.css';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import { QueryClientProvider } from './modules/global/components';
import { useAuthProvider } from 'auth/hooks/authProvider';
import { createRoot } from 'react-dom/client';
import { LoginErrorPage } from 'auth/components/loginErrorPage';

window.store = store;

const RootComponent = () => {
  const { AuthProvider } = useAuthProvider();

  return (
    <Suspense fallback={'...loading'}>
      <BrowserRouter>
        <AuthProvider>
          <QueryClientProvider>
            <Provider store={store}>
              <Routes>
                <Route path="/error/login" element={<LoginErrorPage />} />
                <Route path="/*" element={<App />} />
              </Routes>
            </Provider>
          </QueryClientProvider>
        </AuthProvider>
      </BrowserRouter>
    </Suspense>
  );
};

const root = createRoot(document.getElementById('root'));
root.render(<RootComponent />);
